<template>
    <div>
        <md-card v-if="showHeader === 'true'">
            <md-card-header
                    v-bind:data-background-color="tableHeaderColor"
            >
                <div class="md-layout">
                    <div class="md-layout-item md-medium-size-75 md-xsmall-size-75 md-size-75">
                        <h4 class="title">{{ title }}</h4>
                        <p
                                class="category"
                                v-if="useDatePicker === 'false'">{{ subTitle }}</p>
                        <div
                                v-if="useDatePicker === 'true'">
                            <div class="start-date">
                                <md-datepicker v-model="startDate" md-immediately :md-open-on-focus="false">
                                <label>{{ $t('date_picker_from') }}</label>
                            </md-datepicker></div>
                            <div class="end-date">
                                <md-datepicker v-model="endDate" md-immediately :md-open-on-focus="false">
                                    <label>{{ $t('date_picker_until') }}</label>
                                </md-datepicker>
                            </div>
                        </div>
                    </div>
                    <div
                            class="md-layout-item md-medium-size-25 md-xsmall-size-25 md-size-25"
                            v-if="showFilter === 'true'"
                    >
                        <div class="form">
                            <md-field class="search-box">
                                <label>{{ $t('filter') }}</label>
                                <md-input
                                        class="search-input"
                                        v-model="filter"
                                        v-on:input="filterChanged"
                                ></md-input>
                            </md-field>
                        </div>
                    </div>
                </div>
            </md-card-header>
            <md-card-content>
                <md-table
                          v-model="shownData"
                          v-bind:style="psTable"
                          v-bind:table-header-color="tableHeaderColor"
                          v-bind:md-sort="sortBy"
                          v-bind:md-sort-order="sortOrder"
                          @md-selected="onSelectProxy">
                    <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                            :md-selectable="onSelect ? 'single' : null">
                        <md-table-cell v-bind:md-label="$t('table_header_checkbox')"
                                       v-if="hasCheckbox  === 'true'"
                        >
                            <md-checkbox v-if="item.deliveryDate === null" v-model="selected" v-bind:value="item" v-on:change="onSelectCheckbox"></md-checkbox>
                        </md-table-cell>
                        <md-table-cell v-bind:md-label="$t('table_header_actions')"
                                       v-for="action in actions"
                                       v-bind:key="action.icon"
                        >
                            <div class="action-button"
                                 v-on:click="action.action(item)"
                            >
                                <md-icon class="action-button-icon">{{ action.icon }}</md-icon>
                            </div>
                        </md-table-cell>
                      <md-table-cell
                          v-for="dictItem in dict"
                          v-bind:md-label="$t(dictItem.label)"
                          v-bind:md-sort-by="dictItem.key"
                          v-bind:key="dictItem.key">
                        {{  formatData(item, dictItem) }}
                      </md-table-cell>
                        <md-table-cell md-label=""
                                       v-if="hasRatings  === 'true'"
                                       v-html="showRating(item.rating)"
                        >
                        </md-table-cell>
                    </md-table-row>
                    <div class="loading-overlay" v-if="isLoading">
                        <md-progress-spinner md-mode="indeterminate" :md-stroke="2"></md-progress-spinner>
                    </div>
                </md-table>
            </md-card-content>
        </md-card>
        <md-table
                v-if="showHeader === 'false'"
                v-model="shownData"
                v-bind:style="psTable"
                v-bind:table-header-color="tableHeaderColor"
                v-bind:md-sort="sortBy"
                v-bind:md-sort-order="sortOrder"
                @md-selected="onSelectProxy">
            <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                    :md-selectable="onSelect ? 'single' : null">
                <md-table-cell md-label="Aktionen"
                               v-for="action in actions"
                               v-bind:key="action.icon"
                >
                    <div class="action-button"
                         v-on:click="action.action(item)"
                    >
                        <md-icon class="action-button-icon">{{ action.icon }}</md-icon>
                    </div>
                </md-table-cell>
                <md-table-cell
                        v-for="dictItem in dict"
                        v-bind:md-label="dictItem.label"
                        v-bind:md-sort-by="dictItem.key"
                        v-bind:key="dictItem.key"
                        v-html="formatDataWrapper(item, dictItem)">
                </md-table-cell>
            </md-table-row>
            <div class="loading-overlay" v-if="isLoading">
                <md-progress-spinner md-mode="indeterminate" :md-stroke="2"></md-progress-spinner>
            </div>
        </md-table>
    </div>
</template>

<script>
    import $ from "jquery";
    import store from "@/store"
    import helper from '@/util/helper.js';

    export default {
        name: "PSTable",
        props: {
            title: {
                type: String,
                default: ""
            },
            subTitle: {
                type: String,
                default: ""
            },
            showHeader: {
                type: String,
                default: "true"
            },
            showFilter: {
                type: String,
                default: "false"
            },
            tableHeaderColor: {
                type: String,
                default: "purple"
            },
            data: {
                type: Array,
                required: true
            },
            dict: {
                type: Array,
                required: true
            },
            sortBy: {
                type: String,
                default: ""
            },
            sortOrder: {
                type: String,
                default: "asc"
            },
            height: {
                type: String,
                default: "500"
            },
            actions: {
                type: Array
            },
            hasCheckbox: {
                type: String,
                default: "false"
            },
            onSelectCheckbox: {
                type: Function
            },
            onSelect: {
                type: Function
            },
            hasRatings: {
                type: String,
                default: "false"
            },
            useDatePicker: {
                type: String,
                default: "false"
            },
            onStartDateChanged: {
                type: Function
            },
            onEndDateChanged: {
                type: Function
            },
            onFilterChanged: {
              type: Function
            }
        },
        data: function() {
            return {
                filteredData: [],
                shownData: [],
                selected: [],
                filter: "",
                shownIndex: 100,
                startDate: new Date(2022,0,1),
                endDate: new Date(2023,0,1)
            }
        },
        methods: {
            filterChanged() {
                this.shownIndex = 100;
                this.filter = this.filter.toLowerCase();
                this.filteredData = this.data.filter((item) => {
                    let hasMatch = false;

                    this.dict.some((dictItem) => {
                        //check if any property of the row item has a match with the filter string
                        if (item[dictItem.key] !== null && (item[dictItem.key].toString().toLowerCase().indexOf(this.filter) !== -1)) {
                            hasMatch = true;

                            return true; //Array#some stops execution when an iteration returns true
                        }
                    });

                    return hasMatch;
                });

                this.shownData = this.filteredData.slice(0, this.shownIndex);
            },
            formatData(item, dictItem) {
                switch(dictItem.type) {
                    case "rating":
                        return (item[dictItem.key] || "0") + " / 5";
                    case "date":
                        if (item[dictItem.key] !== null)
                            return new Date(item[dictItem.key]).toLocaleDateString();
                    case "dateTime":
                        if (item[dictItem.key] !== null)
                            return new Date(item[dictItem.key]).toLocaleString();
                    case "price":
                        if (item[dictItem.key] !== null) {
                            return helper.formatNumbers(parseFloat(item[dictItem.key]).toFixed(2).toString().replace(".", ",")) + " €";
                        }
                    case "number":
                        if (item[dictItem.key] !== null) {
                            return helper.formatNumbers(item[dictItem.key]);
                        }
                    case "state":
                        return "";
                    default:
                        return item[dictItem.key];
                }
            },
          formatDataWithHeaders(item, dictItem) {
              return dictItem.label;
          },
            formatDataWrapper(item, dictItem) {
                if (dictItem.type === "state") {
                    return item.state === 5 ?
                        '<span style=\'color: green;\'>' + this.$t('action_done') + '</span>' :
                        (item.state === 0 ?
                            '<span style=\'color: red;\'>' + this.$t('action_required') + '</span>' :
                            '<span style=\'color: orange;\'>' + this.$t('action_pending') + '</span>');
                } else {
                    return this.$t(dictItem.label) + ": " + this.formatData(item, dictItem);
                }
            },
            onSelectProxy(item) {
                this.onSelect(item);
            },
            showRating(rating) {
                if (rating === null) {
                    rating = 0;
                }

                let html = "";

                for (let i = 0; i < Math.floor(rating); i++) {
                    html += "<i class=\"material-icons star\" v-if='this.showStars'>star</i>";
                }

                for (let i = Math.floor(rating); i < 5; i++) {
                    html += "<i class=\"material-icons star\" v-if='this.showStars'>star_outline</i>";
                }

                return html;
            }
        },
        watch: {
            //waiting for the data prop to be loaded, then initialize view
            data: function(val) {
                this.filterChanged();
            },
            startDate: function(val) {
                if (this.onStartDateChanged !== undefined) {
                    this.onStartDateChanged(val);
                }
            },
            endDate: function(val) {
                if (this.onEndDateChanged !== undefined) {
                    this.onEndDateChanged(val);
                }
            },
            filter: function(val) {
                if (this.onFilterChanged !== undefined) {
                  this.onFilterChanged(val);
                }
            }
        },
        created () {
            let component = this;

            //load-on-scroll implementation, shows 100 additional elements on scroll-to-end if available
            $( document ).ready(function() {
                $('.md-scrollbar').on('scroll', function() {
                    if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
                        if (component.shownIndex <= component.data.length) {
                            component.shownIndex += 100;
                            component.shownData = component.filteredData.slice(0, component.shownIndex);
                        }
                    }
                });
            });

            if (this.useDatePicker) {
                if (store.state.startDate !== null) {
                    this.startDate = store.state.startDate;
                } else {
                    store.commit('setStartDate', this.startDate);
                }

                if (store.state.endDate !== null) {
                    this.endDate = store.state.endDate;
                } else {
                    store.commit('setEndDate', this.endDate);
                }
            }

            this.filterChanged();
        },
        computed: {
            //this is necessary so the height can be set as a prop and then used in css
            psTable() {
                return {
                    'height': this.height + 'px'
                }
            },
            isLoading() {
                return store.state.loading;
            }
        }
    }
</script>

<style>
    .start-date .md-field input.md-input,
    .end-date .md-field input.md-input {
        -webkit-text-fill-color: white!important;
    }
</style>

<style scoped>
    .action-button {
        width: 30px;
        height: 30px;
        background: linear-gradient(90deg, #B35175 0%, #80214A 100%);
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
        border-radius: 2px;
        position: relative;
    }
    .action-button:hover {
        cursor: pointer;
    }
    .action-button-icon {
        display: block;
        color: white !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .loading-overlay {
        z-index: 10;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
        width: 100%;
        height: 50%;
        background: rgba(255, 255, 255, 0.5);
        display: flex;
    }
    .start-date {
      width: 250px;
      display: inline-block;
      margin-right: 30px;
    }
    .end-date {
      width: 250px;
      display: inline-block;
      margin-left: 30px;
    }
</style>
